export const VIN_DECODE_API_ID = process.env['VIN_DECODE_API_ID'];
export const VIN_DECODE_API_KEY = process.env['VIN_DECODE_API_KEY'];
export const VIN_DECODE_API_URL = 'https://vindecodervehicle.com/api/v1';

export const VIN_API_MAKE_URL = 'https://vpic.nhtsa.dot.gov/api';
